import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import StandardButton from "../../../components/buttons/StandardButton";
import BasketChangeSetItem from "./BasketChangeSetItem";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";

import ICDoneIcon from '@material-ui/icons/Done';

export default function BasketChangeSet(props) {
    return (<Dialog open={props.showStatus} style={{textAlign: "right"}}>
        <DialogTitle>
            <div className="largeTextBold">
                {messages.basketChangeTitle}
            </div>
        </DialogTitle>

        <DialogContent>
            {props.changeSet.map((product, index) => {
                return <div key={index}>
                    <Divider/>
                    <BasketChangeSetItem product={product}/>
                    <Divider/>
                </div>
            })}
        </DialogContent>

        <div>
            <div className="marginSmall toLeft">
                <StandardButton
                    variant="contained"
                    direction="ltr"
                    icon={<ICDoneIcon/>}
                    text={messages.ok}
                    onClick={() => {
                        props.onSubmitClicked()
                    }}/>
            </div>
        </div>
    </Dialog>)
}